(function () {

	'use strict';
   // document.domain = 'cologic.de';

	/*global $:true */

	let cologicSwAnimations = {


        getEventData: function(){

            var eventData = [];
            $('.gwd-animation-event').each(function(index, item){
                eventData[index] = [];
                eventData[index]['name'] =  $(this).data('event-name');
                eventData[index]['time'] =  $(this).data('event-time');
            });
            // eventData.sort((a, b) => parseFloat(a['time']) - parseFloat(b['time']));
            eventData.sort(function(a, b) {
                return parseFloat(a['time']) - parseFloat(b['time']);
            });
            console.log(eventData)
            return eventData;
        },

        startEventTypo: function(){
            // console.log('inStartEventXX');
            var ea = this.getEventData();
            var tempStartTime = 0;
            ea.forEach(function (item, index) {
                if (item['name'] != 'ende') {
                    if (item['name'] == 'start') {
                        tempStartTime = item['time'];
                        // console.log(tempStartTime);
                        setTimeout(function () {
                            let aniTop = 'head-from-left';
                            let aniBottom = 'head-from-right';
                            let align = 'center';
                            let justify = 'center';
                            if($('#' + item['name']).data('anim')){
                                aniTop += '-'+$('#' + item['name']).data('anim');
                                aniBottom += '-'+$('#' + item['name']).data('anim');
                            }
                            if ($('#' + item['name']).data('justify')) {
                                justify = $('#' + item['name']).data('justify');
                            }
                            if ($('#' + item['name']).data('align')) {
                                align = $('#' + item['name']).data('align');
                            }
                            $('#' + item['name']).css({'display': 'flex'}).parent().css({
                                'align-items': align,
                            });
                            $('#' + item['name']).css({
                                'animation-name': 'parent-visible',
                                'animation-duration': parseInt(ea[index + 1]['time'] - (item['time'])) + 'ms'
                            });
                            $('#' + item['name'] + ' .topLine').css({
                                'animation-name': aniTop,
                                'animation-duration': parseInt(ea[index + 1]['time'] - (item['time'])) + 'ms'
                            });
                            $('#' + item['name'] + ' .bottomLine').css({
                                'animation-name': aniBottom,
                                'animation-duration': parseInt(ea[index + 1]['time'] - (item['time'])) + 'ms'
                            });
                        }, 100);
                        setTimeout(function () {
                            $('#' + item['name']).css({'display': 'none'});
                        }, parseInt(item['time'] + parseInt(ea[index + 1]['time'] - (item['time']+ 1000))));
                    }else{
                        setTimeout(function () {
                            let aniTop = 'head-from-left';
                            let aniBottom = 'head-from-right';
                            let align = 'center';
                            if($('#' + item['name']).data('anim')){
                                aniTop += '-'+$('#' + item['name']).data('anim');
                                aniBottom += '-'+$('#' + item['name']).data('anim');
                            }
                            if($('#' + item['name']).data('align')){
                                align = $('#' + item['name']).data('align');
                            }
                            $('#' + item['name']).css({'display': 'flex'}).parent().css({
                                'align-items':align});
                            $('#' + item['name']).css({
                                'animation-name': 'parent-visible',
                                'animation-duration': parseInt(ea[index + 1]['time'] - (item['time'])) + 'ms'
                            });
                            $('#' + item['name'] + ' .topLine').css({
                                'animation-name': aniTop,
                                'animation-duration': parseInt(ea[index + 1]['time'] - (item['time'])) + 'ms'
                            });
                            $('#' + item['name'] + ' .bottomLine').css({
                                'animation-name': aniBottom,
                                'animation-duration': parseInt(ea[index + 1]['time'] - (item['time'])) + 'ms'
                            });
                        }, parseInt(item['time']));
                        setTimeout(function () {
                            $('#' + item['name']).css({'display': 'none'});
                        }, parseInt(item['time'] + parseInt(ea[index + 1]['time'] - (item['time']+ 500))));
                    }


                } else {
                    item['name'] = 'start';
                    setTimeout(function () {
                        let align = 'center';
                        if($('#' + item['name']).data('align')){
                            align = $('#' + item['name']).data('align');
                        }
                        $('#' + item['name']).css({'display': 'flex'}).parent().css({
                            // 'justify-content': justify ,
                            'align-items':align});
                        $('#' + item['name']).css({'display': 'flex'});
                        $('#' + item['name'] + ' .topLine').css({
                            'animation-name': 'head-from-left-final',
                            'animation-duration': parseInt(tempStartTime) + 'ms'
                        });
                        $('#' + item['name'] + ' .bottomLine').css({
                            'animation-name': 'head-from-right-final',
                            'animation-duration': parseInt(tempStartTime) + 'ms'
                        });
                        setTimeout(function () {
                            $('#' + item['name'] + ' .topLine').css({
                                'transform': 'translateX(30%)'
                            });
                            $('#' + item['name'] + ' .bottomLine').css({
                                'transform': 'translateX(-40%)'
                            });
                            $('#replayAniButton').css({
                                'display': 'flex'
                            });
                        }, parseInt(tempStartTime));

                    }, parseInt(item['time']));

                }
            });
        },


        replayAni: function(){
            console.log('inReplayAni!');
            $('#replayAniButton').css({
                'display': 'none'
            });


            let container =  $( "#bikeAnimationFrame" ).contents().find( "#pagedeck" );
            let content = $(container).html();
            $(container).html(content);
            document.getElementById('bikeAnimationFrame').contentWindow.cologic.startEventTypo();
            // cologic.startEventTypo();
        },

        getHeaderAniHtml: function(mapHandlerURL, replaceString, ajaxCallback){

            var trgAdress = mapHandlerURL;
            // console.log('mapHandlerURL:');
            // console.log(mapHandlerURL);
            $.ajax({
                type: 'get',
                context: document,
                // cache: false,
                url: trgAdress
            })
                .done(function(data) {
                    try{
                        let response;
                        let responseTemp;
                        // console.log(data);
                        responseTemp = data.replace(/gwd-image/g, 'image');

                        let relpaceTerm = 'src="' + replaceString;
                        response = responseTemp.replace(/source=\"/g, relpaceTerm);

                        let result = [];
                        result['pagedeck'] = $(response).find('#pagedeck div, #pagedeck img');
                        // result['styles'] = $(response).filter('style')[5];

                        //Style-Tag-ID = clc-ani-main
                        result['styles'] = $(response).filter('#clc-ani-main');
                        let response_out = result;
                        // console.log('response:');
                        // console.log(response_out);
                        if (ajaxCallback)
                            ajaxCallback(response_out);
                        return (response_out);
                        // return(result);

                    }catch(err){
                        alert("Fehler: " + err);
                    }
                })
                .fail(function(err) {
                    alert("Es ist ein Fehler aufgetreten: " + err);
                });

        },


        startAniInit:  function() {
            // console.log('startAniInit 1!!')
            let that = this;

            if ($('#dataContAni').length > 0) {
                // console.log('startAniInit 2!!')
                this.getHeaderAniHtml($('#dataContAni').data('anifolder'), $('#dataContAni').data('aniindexpath'), function (response_Data) {
                    // console.log('startAniInit 3!!')
                    if (response_Data) {
                        // console.log('startAniInit 4!!')
                        console.log(response_Data['styles']);
                        $(response_Data['pagedeck']).appendTo($('#pagedeckContainer .gwd-div-1ba6'));
                        $('head').append(response_Data['styles']);
                        // setTimeout(function(){

                        // window.addEventListener('load', () => {
                                // cologic.init();
                            that.startBanner();
                            that.setReplayEvent();
                        // });

                        // if (window.attachEvent) {
                        //     window.attachEvent('onload',this.startBanner);
                        // } else {
                        //     if (window.onload) {
                        //         var curronload = window.onload;
                        //         var newonload = function () {
                        //             curronload();
                        //             this.startBanner();
                        //         };
                        //         window.onload = newonload;
                        //     } else {
                        //         // window.onload = startBanner;
                        //         this.startBanner();
                        //     }
                        // }
                        // }, 600);

                    } else {
                        $('#aniAjaxTest').html('Es ist ein Fehler aufgetreten.');

                    }
                });
            }
        },

        addClass: function( classname, element ) {
            var cn = element.className;
            if( cn.indexOf( classname ) != -1 ) return;
            if( cn != '' ) classname = ' '+classname;
            element.className = cn+classname;
        },


        startBanner: function() {
            let that = this;
            setTimeout(function () {
                var page = document.getElementById("page1");
                that.addClass('gwd-play-animation', page);

                let allWidth = $('.image-slider--container').innerWidth();
                var barrierVal = 0;
                // if (allWidth > 767){
                console.log('inBanner!!')
                that.startEventTypo();
                // }
            }, 700);

        },


        setReplayEvent: function(){
            let that = this;
            setTimeout(function(){
                $('.image-slider--thumbnails-slide .thumbnail--link').first().on('click', function(event){
                    console.log('YEAHH CLICK IT!');
                    // console.log(event.origin);
                    // if (event.origin !== 'https://test.cologic.de/') return;

                    event.stopPropagation();
                    cologic.replayAni();
                });
            }, 700);

        }






    };

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicSwAnimations);
}());